<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :visible="isShowSetting"
    :title="$t('lianmai.连麦申请设置')"
    class="dialog-dark dialog-center lianmai-setting"
    width="300px"
    @close="closeDialog"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="av-lianmai">
      <div class="top">
        <div class="switch-label">
          {{ $t("lianmai.开启音视频连线") }}
        
          <div :class="['exclamation-tips', {'show-exclamation-tips': isShowExclamationTips}]">
            <span
              class="exclamation-icon"
              @mouseenter="isShowExclamationTips = true"
              @mouseleave="isShowExclamationTips = false"
            ><img :src="require('@/svg/exclamation.svg')" /></span>

            <div class="content" v-if="isShowExclamationTips">
              <p>{{ $t("lianmai.以下场景下开启音视频连线不生效") }}</p>
              <p>{{ $t("lianmai.当前直播间为纯音频直播间") }}</p>
              <p>{{ $t("lianmai.当前直播间视频源比例为") }}9:16</p>
              <p>{{ $t("lianmai.当前直播源不为主播端") }}</p>
              <p>{{ $t("lianmai.当前直播类型必须为标准直播") }}</p>
            </div>
          </div>
        </div>
        <el-switch
          v-model="isAVLianmai"
          :class="['blueSwitch', 'form-dark', {'intiative-disabled': isDisableAVLianmai()}]"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @click.native="isDisableAVLianmai() ? undefined : openCloseIsAVLianmai()"
          :disabled="true"
        ></el-switch>
      </div>
      <div class="bottom">{{ $t("lianmai.开启or关闭后，列表中已申请中的观众需要重新进行连麦申请") }}</div>
    </div>

  </el-dialog>
</template>

<script>
import { Dialog } from "element-ui";
import { mapGetters } from "vuex";

export default {
  name: "lianmaiSetting",
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    opType: Number,
    isShowSetting: {
      type: Boolean,
      default: false,
    },
    isAVLianmai: {
      type: Boolean,
      default: false,
    },
    lianmaiCount: {
      type: Number,
      default: 0,
    },
    applyUserTotalCount: {
      type: Number,
      default: 0,
    },
    isAllowSetAVLianmai: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isShowExclamationTips: false
    };
  },
  computed: {
    ...mapGetters(["liveConfig"]),
  },
  watch: {
    /**防止主播打开设置时没人，然后有人申请通过时显示问题，助手亦可点击同意*/
    lianmaiCount: {
      handler(val) {
        if(val == 1){
          this.isDisableAVLianmai()
        }
      },
      immediate: true,
    }
  },
  methods: {
    closeDialog() {
      this.$emit("clodeSettingDialog");
    },
    openCloseIsAVLianmai () {
      console.log('call openCloseIsAVLianmai, isAVLianmai:', this.isAVLianmai);

      // qgs 不需要二次确认了，注释掉代码
      // if (this.applyUserTotalCount || this.lianmaiCount) {
      //   this.$confirm(this.$t('lianmai.切换后当前申请中的观众需要重新进行连麦申请，确定修改吗'), this.$t('lianmai.提示'), {
      //     confirmButtonText: this.$t('lianmai.确定'),
      //     cancelButtonText: this.$t('lianmai.取消'),
      //   }).then(() => {
      //     this.$emit('changeIsAVLianmai');
      //   }).catch(() => {
      //     console.log('cacel openCloseIsAVLianmai, isAVLianmai:', this.isAVLianmai);
      //   })
      //   return;
      // }

      this.$emit('changeIsAVLianmai');
    },
    isDisableAVLianmai () {
      // 该直播不能为【纯音频】直播，该直播视频源比例不能为【9:16】, 当前直播源必须为【主播端】，当前直播类型必须为标准直播
      const {liveConfig, liveRoomType} = this.$store.getters;

      console.log(
        'isDisableAVLianmai, liveRoomType:', liveRoomType, ',default_play_type:', liveConfig.default_play_type,
        ',video_source_ratio:', liveConfig.video_source_ratio, ',opType:', this.opType, ',lianmaiCount:', this.lianmaiCount
      );

      if (this.lianmaiCount > 0) // 连麦人数大于 0
        return true;
      
      if (
        liveConfig.default_play_type == 1 // 该直播不能为【纯音频】直播, default_play_type 直播类型是音视频还是纯音频, 0: 音视频 1：纯音频
        || liveConfig.video_source_ratio == 1 // 该直播视频源比例不能为【9:16】, video_source_ratio 视频源比例 0=16:9 1=9:16
        || liveRoomType != 0 // 当前直播类型必须为标准直播， 直播间类型 LiveRoomTypeEnum, 0 = 标准直播 1 = 虚拟直播
        || this.opType != 0 // 当前直播源必须为【主播端】, opType:0 真直播   opType：3 伪直播    opType:2 第三方拉流
      ) {
        return true;
      }
      
      return false;
    }
  },
};
</script>

<style scoped lang="scss">
.lianmai-setting ::v-deep {
  font-size: 12px;

  .el-dialog,
  .el-dialog .el-dialog__body {
    overflow: visible;
  }

  .el-dialog__header {
    text-align: left !important;
  }

  .blueSwitch {
    float: right;
  }

  .av-lianmai {
    margin-bottom: 10px;

    .switch-label {
      display: inline-block;

      .exclamation-icon {
        padding: 6px 6px;
        position: relative;
        left: -1px;
        top: 3px;
        
        img {
          height: 15px;
        }
      }

      .exclamation-tips {
        display: inline-block;
        position: relative;
        
        &.show-exclamation-tips::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          transform: translate(3%, -30px);
          width: 0;
          height: 0;
          border-left: 10px solid transparent; /* 左边透明边框 */
          border-right: 10px solid transparent; /* 右边透明边框 */
          border-top: 10px solid black; /* 顶部黑色边框，形成倒三角 */
        }

        .content {
          position: absolute;
          background: rgba(0, 0, 0, 0.9);
          padding: 13px;
          left: 0;
          bottom: 0px;
          transform: translate(-54%, -37px);
          border-radius: 5px;

          p {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 17px;
            white-space: nowrap;
            letter-spacing: 2px;
          }
        }
      }
    } 

    .el-switch.is-disabled:not(.intiative-disabled) {
      opacity: 1;

      .el-switch__core,
      .el-switch__label {
        cursor: pointer;
      }
    }

    .bottom{
      color:  #ACB2BF;
      padding-top: 4px;
    }
  }
}
</style>
